<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <z-tabs
        id="client-tabs"
        v-model="currentTab"
        :tabs="tabs"
        :badges="badges"
        :useScroll="useScroll"
        :showNumTabs="5"
        :isFill="isFill"
        @change="showTab"
      />
      <div class="row p-3" v-if="currentTab === 'Bio'">
        <member-basic ref="Basic" @changed="changed" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Coach Wall'">
        <coach-wall ref="CoachWall" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Activity'">
        <member-exercise
          ref="Exercise"
          @changed="changed"
          @weekChanged="weekChanged"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Nutrition'">
        <member-nutrition
          ref="Nutrition"
          @weekChanged="weekChanged"
          @changed="changed"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Body Comp'">
        <member-body-comp ref="BodyComposition" @changed="changed" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Measurements'">
        <member-measurements
          ref="Measurements"
          @weekChanged="weekChanged"
          @changed="changed"
        />
      </div>
      <div class="row p-3" v-if="currentTab === dashboardName">
        <client-dashboard
          ref="Dashboard"
          @weekChanged="weekChanged"
          @changed="changed"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Challenge'">
        <member-challenge
          ref="Challenges"
          @weekChanged="weekChanged"
          @changed="changed"
        />
      </div>
      <div class="row" v-if="currentTab === 'VO2 Max'">
        <member-assessment ref="Assessment" @statusSave="statusSave" />
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6">
          <div class="custom-id">
            <span class="me-2">id:</span>
            <span>{{ id }}</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button
              v-show="!isSaved"
              class="btn btn-primary me-2"
              :disabled="isSaving"
              @click="save"
            >
              <i v-if="isSaving" class="fas fa-spinner fa-spin"></i>
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MemberBasic from './client-basic'
import MemberExercise from './client-exercise'
import MemberBodyComp from './client-bodycomp'
import MemberNutrition from './client-nutrition'
import MemberChallenge from './client-challenge'
import MemberMeasurements from './client-measurements'
import ClientDashboard from './client-dashboard'
import MemberAssessment from './client-assessment'
import CoachWall from './client-coachwall'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTabs from '@/Components/ZElements/Tabs'
export default {
  name: 'client-dialog',
  components: {
    ZDialog,
    ZTabs,
    MemberBasic,
    MemberExercise,
    MemberBodyComp,
    MemberNutrition,
    MemberChallenge,
    MemberMeasurements,
    ClientDashboard,
    CoachWall,
    MemberAssessment,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
      currentTab: 'Bio',
      invalidMessage: '',
      viewedTabs: ['Bio'],
      isDirty: false,
      useScroll: false,
      isFill: false,
      isSaved: true,
      isSaving: false,
    }
  },
  mounted() {
    this.isDirty = false
    this.invalidMessage = ''
  },
  emits: ['close', 'saved'],
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('usercardio', ['member', 'summary']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Profile'
      if (this.member) {
        _title += ` for ${this.member.firstName} ${this.member.lastName}`
      }
      return _title
    },
    id() {
      let _id = null
      if (this.member) {
        _id = this.member.id
      }
      return _id
    },
    dashboardName() {
      let _data = ''
      if (this.summary) {
        if (this.summary.organization) {
          if (this.summary.organization.dashboardName !== null) {
            _data = this.summary.organization.dashboardName
          }
        }
      }
      return _data
    },
    tabs() {
      let _tabs = [
        'Bio',
        'Coach Wall',
        'Activity',
        'Nutrition',
        'Body Comp',
        'Measurements',
      ]
      if (this.dashboardName !== '') {
        if (this.dashboardName !== 'Custom Panel') {
          _tabs.push(this.dashboardName)
        }
      }
      _tabs.push('Challenge')
      if (this.isAssessment) {
        _tabs.push('VO2 Max')
      }
      return _tabs
    },
    badges() {
      let _data = [
        {
          name: 'Coach Wall',
          count: 0,
        },
      ]
      if (this.member) {
        if (this.member.unread) {
          let count = parseInt(this.member.unread[0].unread_messages)
          if (count > 0) {
            if (count > 99) {
              _data[0].count = '99+'
            } else {
              _data[0].count = count
            }
          }
        }
      }
      return _data
    },
    isAssessment() {
      let _is = false
      if (this.summary) {
        if (this.summary.organization) {
          if (parseInt(this.summary.organization.assessmentVisibility) === 1) {
            _is = true
          }
        }
      }
      return _is
    },
    isDashboard() {
      let _is = false
      if (this.summary) {
        if (this.summary.organization) {
          if (parseInt(this.summary.organization.dashboardVisibility) === 1) {
            _is = true
          }
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('usercardio', ['setCustomView']),
    async showTab(value) {
      this.isSaved = true
      this.isSaving = false
      this.viewedTabs.push(value)
      this.currentTab = value
    },
    changed() {
      this.isDirty = true
    },
    weekChanged(date) {
      console.log('Week Changed', {
        currentTab: this.currentTab,
        week: date,
        viewed: this.viewedTabs,
      })
    },
    close() {
      this.currentTab = 'Bio'
      this.viewedTabs = ['Bio']
      this.$emit('close', this.isDirty)
      this.isDirty = false
    },
    statusSave(status) {
      this.isSaved = status.isSaved
      this.isSaving = status.isSaving
    },
    save() {
      this.$refs.Assessment.save()
    },
  },
}
</script>
<style scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-id {
  display: none;
  width: 100%;
}
</style>
